import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, BellOff, BellRing } from "lucide-react";
import { Button } from "@/components/ui/button";
import { enablePushNotifications, disablePushNotifications, getPushStatus } from "@/lib/push";

export function PushToggle({ className = "" }) {
  const [status, setStatus] = useState("loading");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getPushStatus().then(setStatus).catch(() => setStatus("unsupported"));
  }, []);

  if (status === "unsupported") {
    return (
      <div className={`text-sm text-[#7248ae] inline-flex items-center gap-2 ${className}`} data-testid="push-unsupported">
        <BellOff className="h-4 w-4" />Push no soportado en este navegador
      </div>
    );
  }
  if (status === "denied") {
    return (
      <div className={`text-xs inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#fcfbfd] border border-[#e11d48]/30 text-[#9f1239] ${className}`} data-testid="push-denied" title="Activa las notificaciones en el candado/ícono junto a la URL para recibir alertas de inventario, mensajes del Owner y solicitudes urgentes.">
        <BellOff className="h-3.5 w-3.5" />
        <span>Notificaciones bloqueadas</span>
      </div>
    );
  }

  const enable = async () => {
    setBusy(true);
    try {
      await enablePushNotifications();
      toast.success("Notificaciones activadas");
      setStatus("enabled");
    } catch (e) {
      toast.error(e.message);
    } finally { setBusy(false); }
  };

  const disable = async () => {
    setBusy(true);
    try {
      await disablePushNotifications();
      toast.success("Notificaciones desactivadas");
      setStatus("disabled");
    } catch (e) {
      toast.error(e.message);
    } finally { setBusy(false); }
  };

  if (status === "enabled") {
    return (
      <Button onClick={disable} disabled={busy} variant="outline" className={`border-[#10b981]/40 text-[#10b981] hover:bg-[#10b981]/10 ${className}`} data-testid="push-disable-button">
        <BellRing className="h-4 w-4 mr-2" />Notificaciones activas
      </Button>
    );
  }
  return (
    <Button onClick={enable} disabled={busy} variant="outline" className={`border-[#b182ec]/50 ${className}`} data-testid="push-enable-button">
      <Bell className="h-4 w-4 mr-2" />Activar notificaciones
    </Button>
  );
}

export default PushToggle;
